module.exports = __webpack_public_path__ + "static/media/jmmartinez2.81a72b92.jpg";